//import { LitElement, html, css, live } from './lit.js';
import { html } from 'lit-html';
import { LitElement, css } from 'lit-element';
import { effect_duration_change } from "../interface_functions.js"

class AdditionalBlockDuration extends LitElement {

    static properties = {
        effect_id: { type: String },
        display_duration: { type: Number }
    };

    static styles = css`
        hr.divider {
            margin: 0;
            background-color: var(--interface-secondary-color);
            height: 1px;
            border: none;
        }

        div.flex_row {
            display: flex;
            flex-direction: row;
        }

        div.vertically_centered
        {
            margin: auto 0;
        }

        input.stacks_direct {
            width : 45px;
            height : 24px;
            background-color: transparent;
            color: var(--interface-font-color);
            border: 1px solid var(--interface-secondary-color);
            font-size: 16px;
            text-align: center;
            margin: 0px 5px 0px 10px;
            padding: 0;
        }

        input.stacks_direct::-webkit-outer-spin-button,
        input.stacks_direct::-webkit-inner-spin-button {
            -webkit-appearance: none;
        }

        input.stacks_direct[type=number] {
            -moz-appearance: textfield; /* Firefox */
        }

        div.default_padding_block
        {
            padding: 10px;
        }
    `;

    onInput(event)
    {
        let value = parseFloat(event.target.value);

        if (value < 0 )
        {
            event.target.value = 0;
            value = 0
        }

        effect_duration_change(this.effect_id, value)
    }

    setDuration(newVal)
    {
        this.display_duration = newVal;
        console.log("update duration add block, to", this.display_duration)

        this.requestUpdate();
    }

    constructor(effect_id) {
        super();
        this.effect_id = effect_id; // Значение по умолчанию
        this.display_duration = 0;
    }

    render() {
        return html`
            <hr class="divider">
            <div class='flex_row default_padding_block'>
                <div class="vertically_centered">Duration: </div>
                <input class='stacks_direct' min='0' max='1000' type="number" .value="${this.display_duration}" @input=${this.onInput}/>
                <div class="vertically_centered">[s]</div>
            </div>
        `;
    }
}

customElements.define('additional-block-duration', AdditionalBlockDuration);

export function CreateAdditionalBlockDuration(effect_id)
{
    let additionalBlockDuration = new AdditionalBlockDuration(effect_id);
    additionalBlockDuration.id = `${additionalBlockDuration.effect_id}_duration`;

    return additionalBlockDuration;
}